import ContactsCards from './ContactsCards.component';

export default ContactsCards;
